import { $el, $list } from 'src/scripts/utils/utils'
import { replaceNodeChildren } from '../../utils/dom'
import { BaseComponent } from '../base-component'

const PAGINATION_COMPONENT_SELECTOR = 'pagination-component'

export class PaginationComponent extends BaseComponent {
  updateTargetsFromHTML(html: Document): void {
    if (!this.dataset.containerId) {
      return
    }

    const newResults = $el(`#${this.dataset.containerId}`, html)
    const results = $el(`#${this.dataset.containerId}`)

    if (newResults && results) {
      const targets = $list(`.${this.dataset.target}`, newResults)
      const fragment = document.createDocumentFragment()

      targets.forEach(target => {
        fragment.appendChild(target)
      })

      results.appendChild(fragment)
    }
  }

  updateResultsFromHTML(html: Document): void {
    if (!this.dataset.containerId) {
      return
    }

    const newResults = $el(`#${this.dataset.containerId}`, html)
    const results = $el(`#${this.dataset.containerId}`)

    if (newResults && results) {
      const resultsParentNode = results.parentNode

      resultsParentNode.replaceChild(newResults, results)

      newResults.scrollIntoView({ behavior: 'smooth' })
    }
  }

  updateFromHTML(html: Document): void {
    const newPagination = $el(PAGINATION_COMPONENT_SELECTOR, html)
    replaceNodeChildren(this, newPagination)
  }

  get loadingOverlay(): HTMLElement {
    return $el(`#${this.dataset.overlayId}`)
  }
}
